import type { StatsFilters } from './types';

import { Order } from '@shared-types/common.types';
import type { StatisticDefinition } from '@shared-types/stats.types';
import type { StateCreator } from '@shared-types/zustand.types';

type CategorySlice = {
  category: string;
  setCategory: (category: string) => void;
};

export const categorySlice: StateCreator<CategorySlice> = (set) => ({
  category: null,
  setCategory: (category: string) => set(() => ({ category }), false, 'setCategory'),
});

type FiltersSlice = {
  filters: StatsFilters;
  setFilters: (filters: StatsFilters) => void;
};

export const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: null,
  setFilters: (filters: StatsFilters) => set(() => ({ filters }), false, 'setFilters'),
});

type SortingSlice = {
  sorting: StatisticDefinition;
  setSorting: (sorting: StatisticDefinition) => void;
};

export const sortingSlice: StateCreator<SortingSlice> = (set) => ({
  sorting: null,
  setSorting: (sorting: StatisticDefinition) => set(() => ({ sorting }), false, 'setSorting'),
});

type OrderSlice = {
  order: Order;
  setOrder: (order: Order) => void;
};

export const orderSlice: StateCreator<OrderSlice> = (set) => ({
  order: Order.DESC,
  setOrder: (order: Order) => set(() => ({ order }), false, 'setOrder'),
});

export type StatisticState = CategorySlice & FiltersSlice & SortingSlice & OrderSlice;
